import { Environment } from '@flexbenefits-ui/data-access-api';

export const environment: Environment = {
    production: false,
    apiUrl: 'https://flexbenefits.youforceacc.com/gateway/api/v1',
    userInfoApiUrl: 'https://user.youforceacc.com/info',
    appName: 'FlexBenefits',
    version: '1.0.0',
    features: {
        enableDebugMode: false,
        enableMockData: false,
    },
    auth: {
        tokenKey: 'auth_token',
        refreshTokenKey: 'refresh_token',
    },
    youforceNavigationBar: {
        styleUrl:
            'https://static.youforceacc.com/mijn-youforce/navigation-bar/release/youforce-navigation-bar/youforce-navigation-bar.css',
        scriptUrl:
            'https://static.youforceacc.com/mijn-youforce/navigation-bar/release/youforce-navigation-bar/youforce-navigation-bar.esm.js',
    },
    loginUrl: 'https://login.youforceacc.com',
    homeUrl: 'https://flex.youforceacc.com/',
    appInsights: {
        instrumentationKey: '8407a8ea-7d30-46f3-b4d0-dbe98003bb1d',
    },
};
